export default function () {
  return {
    name: "Generalized Anxiety Screening",
    description:
      "We can help you find out if medication might help with your generalized anxiety",
    version: "2025101101",
    service_code: "GENERALIZED_ANXIETY_FOLLOW_UP",
    live: true,
    staged: true,
    questions: [
      {
        title: "Has the medication been effective for you?",
        description: "",
        type: "radio",
        choices: [
          {
            label: "Yes",
            silent: true,
          },

          {
            label: "No",
            children: [
              {
                title: "Why didn't you find the medication effective?",
                description:
                  "Please tell us in as much detail as you can about your experience with the medication.",
                code: "medication-effective",
                type: "textarea",
              },
            ],
          },
        ],
      },
      {
        title: "Have you experienced any side effects from the medication?",
        description: "",
        type: "radio",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title: "What side effects did you experience?",
                description:
                  "Please tell us in as much detail as you can about the side effects you experienced with the medication.",
                code: "medication-side-effects",
                type: "textarea",
              },
            ],
          },
          {
            label: "No",
            silent: true,
          },
        ],
      },

      {
        title:
          "Are you currently taking any other prescription or over-the-counter medicines, herbals, or supplements?",
        description:
          "Please include all current medications and supplements, and also any medications you finished recently, including topical medicines, injections, vitamins, herbal remedies, or any other products you use.",
        code: "medications-radio",
        type: "radio",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title: "What medicines, herbals, or supplements do you use?",
                description:
                  "Please list the dose and why you are taking each medicine or supplement.",
                code: "medications",
                type: "textarea", // @todo multi-select autocomplete
              },
            ],
          },
          {
            label:
              "No, not taking any medicines, supplements, herbals, or other prescriptions",
            silent: true,
          },
        ],
      },
      {
        title:
          "Have you had any surgeries or hospitalizations since your last Kick visit?",
        description:
          "Include any significant emergency room visits, hospital stays, or surgeries, including cosmetic surgeries.",
        type: "radio",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title: "What surgeries or hospitalizations have you had?",
                description:
                  "List all the procedures and events and try to remember when they occurred.",
                code: "hospitalizations",
                type: "textarea",
              },
            ],
          },
          {
            label: "No surgeries or hospitalizations",
            silent: true,
          },
        ],
      },

      {
        title: "Do you have any of the following conditions?",
        description:
          "Even if they were in the past, certain conditions can complicate diagnosis, increase risks, or change the recommended treatments so it's critical we know your full history.",
        type: "checkbox",
        code: "conditions",
        choices: [
          {
            label:
              "Any problems with poor circulation, or cold or blue extremities?",
          },
          {
            label: "Are you pregnant?",
          },
          {
            label: "Are you breastfeeding?",
          },
          {
            label: "Do you take any medication to lower blood pressure?",
            children: [
              {
                title:
                  "Please list your blood pressure medications and dosages if you know them.",
                description:
                  "list your blood pressure medications and dosages if you know them",
                code: "blood-pressure-medication-details",
                type: "textarea",
              },
            ],
          },
          {
            label: "Any liver problems?",
          },
          {
            label: "Any kidney problems?",
          },
          {
            label: "Hyperthyroidism?",
          },
          {
            label: "Hypotension or low blood pressure?",
          },
          {
            label:
              "Are you currently experiencing any symptoms of sexual dysfunction?",
          },
          {
            label: "Do you have glaucoma?",
          },
          {
            label:
              "Ever been diagnosed with any mental disorders such as bipolar disorder or schizophrenia?",
            children: [
              {
                title: "What mental disorders have you been diagnosed with?",
                description:
                  "List the disordera and if possible, when you were diagnosed.",
                code: "mental-disorders",
                type: "textarea",
              },
            ],
          },
          {
            label:
              "Ever been diagnosed with any neurological disorder such as Parkinson's disease or dementia?",
            children: [
              {
                title:
                  "What neurological disorders have you been diagnosed with?",
                description:
                  "List the disordera and if possible, when you were diagnosed.",
                code: "neurological-disorders",
                type: "textarea",
              },
            ],
          },
          {
            label: "None of the above",
            silent: true,
          },
        ],
      },

      {
        title: "Have you ever: ",
        type: "checkbox",
        choices: [
          {
            label:
              "Felt you need to cut down on use of a substance (alcohol, cocaine, cannabis, etc)",
          },
          {
            label: "Been annoyed by people criticizing your use of substances?",
          },
          {
            label: "Felt guilty about your use of a substance?",
          },
          {
            label:
              "Needed a drink first thing in the morning as an eye-opener?",
          },
          {
            label: "None of the above",
            silent: true,
          },
        ],
      },

      {
        title:
          "Do you have any concerns about your mood, depression, anxiety or worrying?",
        code: "PHQ-GAD-2",
        type: "radio",
        choices: [
          {
            label: "No",
            silent: true,
          },
          {
            label: "Yes",
            children: [
              {
                title:
                  "Over the past two weeks, how often have you felt little interest or pleasure in doing things?",
                code: "PHQ2-1",
                type: "radio",
                choices: [
                  {
                    label: "Not At all",
                  },
                  {
                    label: "Several Days",
                  },
                  {
                    label: "More than Half the Days",
                  },
                  {
                    label: "Nearly Every Day",
                  },
                ],
              },
              {
                title:
                  "Over the past two weeks, how often have you felt down, depressed or hopeless?",
                type: "radio",
                code: "PHQ2-2",
                choices: [
                  {
                    label: "Not At all",
                  },
                  {
                    label: "Several Days",
                  },
                  {
                    label: "More than Half the Days",
                  },
                  {
                    label: "Nearly Every Day",
                  },
                ],
              },
              {
                title:
                  "Over the past two weeks, how often have you felt nervous, anxious, or on edge?",
                type: "radio",
                code: "GAD2-1",
                choices: [
                  {
                    label: "Not At all",
                  },
                  {
                    label: "Several Days",
                  },
                  {
                    label: "More than Half the Days",
                  },
                  {
                    label: "Nearly Every Day",
                  },
                ],
              },
              {
                title:
                  "Over the past two weeks, how often have you not been able to stop or control worrying?",
                code: "GAD2-2",
                type: "radio",
                choices: [
                  {
                    label: "Not At all",
                  },
                  {
                    label: "Several Days",
                  },
                  {
                    label: "More than Half the Days",
                  },
                  {
                    label: "Nearly Every Day",
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        title: "Any dosage or medication updates on this follow-up visit?",
        description:
          "We'll pass this information to your doctor to help determine the best course of treatment",

        type: "radio",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title: "What would you like to request?",
                code: "special-requests-radio",
                type: "radio",
                choices: [
                  {
                    label: "I would like to try a different medication",
                  },
                  {
                    label: "I would like to adjust my current dosage",
                  },
                ],
              },
            ],
          },
          {
            label: "No, we can move on",
            silent: true,
          },
        ],
      },

      {
        title: "Anything else you would like your doctor to know?",
        description:
          "Before we wrap up, any final things you'd like to tell your doctor? Feel free to ask questions as well.",

        type: "radio",
        choices: [
          {
            label: "Yes",
            children: [
              {
                title: "What would you like to tell your doctor?",
                code: "doctor-let-know",
                type: "textarea",
              },
            ],
          },
          {
            label: "No, we can move on",
            silent: true,
          },
        ],
      },
    ],
  };
}

// -------------------------------------------------------
//
// CHANGELOG
//
// Version 2025101001
// - Add question code 'medications-radio' to medications question for EMR highlighting support
//
// -------------------------------------------------------
// Version 2025061801
// - Initial version based on performanceAnxietyFollowUp.js
// - Removed blood pressure questions (systolic and diastolic)
// - Updated medication request options to be more generic for GA
// - Changed service_code to GENERALIZED_ANXIETY_FOLLOW_UP
//
// -------------------------------------------------------
